import { supabase } from "../../../../supabaseClient.js";
import { ahora } from "../../../../utils/fechas.js";

export async function insertarFactura(factura) {
  const payload = {
    numero_factura: factura.numeroFactura,
    fecha_factura: factura.fecha,
    total: factura.total,
    estado: factura.estado,
    fecha_registro: ahora(), // Usar la función ahora() para obtener la fecha actual en la zona horaria configurada
    usuario_codigo: factura.usuarioCodigo ?? 3, // default temporal (Sonia)
  };

  const { data, error } = await supabase
    .from("facturas")
    .insert(payload)
    .select(`
      id_factura,
      numero_factura,
      fecha_factura,
      total,
      estado,
      fecha_registro,
      usuario_codigo
    `)
    .single();

  if (error) {
    console.error("Error insertando factura:", error);
    throw error;
  }

  // 👇 salida controlada y clara para el frontend
  return {
    idFactura: data.id_factura,
    numeroFactura: data.numero_factura,
    fechaFactura: data.fecha_factura,
    total: data.total,
    estado: data.estado,
    usuarioCodigo: data.usuario_codigo,
  };
}

